import { render, staticRenderFns } from "./SelectDepartamentos.vue?vue&type=template&id=82dc9594&"
import script from "./SelectDepartamentos.vue?vue&type=script&lang=js&"
export * from "./SelectDepartamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports